var map = {
	"./VTT.svg": "./app/assets/custom/vehicleIcons/VTT.svg",
	"./back-hoe.svg": "./app/assets/custom/vehicleIcons/back-hoe.svg",
	"./chaloupe.svg": "./app/assets/custom/vehicleIcons/chaloupe.svg",
	"./chariot-elevateur.svg": "./app/assets/custom/vehicleIcons/chariot-elevateur.svg",
	"./compresseur.svg": "./app/assets/custom/vehicleIcons/compresseur.svg",
	"./conveyor.svg": "./app/assets/custom/vehicleIcons/conveyor.svg",
	"./default-veh.svg": "./app/assets/custom/vehicleIcons/default-veh.svg",
	"./dents-defonceuse.svg": "./app/assets/custom/vehicleIcons/dents-defonceuse.svg",
	"./excavatrice.svg": "./app/assets/custom/vehicleIcons/excavatrice.svg",
	"./foreuse.svg": "./app/assets/custom/vehicleIcons/foreuse.svg",
	"./forklift.svg": "./app/assets/custom/vehicleIcons/forklift.svg",
	"./generator.svg": "./app/assets/custom/vehicleIcons/generator.svg",
	"./godet-a-dents.svg": "./app/assets/custom/vehicleIcons/godet-a-dents.svg",
	"./grove.svg": "./app/assets/custom/vehicleIcons/grove.svg",
	"./jack-hydraulique.svg": "./app/assets/custom/vehicleIcons/jack-hydraulique.svg",
	"./lighting-tower.svg": "./app/assets/custom/vehicleIcons/lighting-tower.svg",
	"./loader.svg": "./app/assets/custom/vehicleIcons/loader.svg",
	"./minivan.svg": "./app/assets/custom/vehicleIcons/minivan.svg",
	"./paver.svg": "./app/assets/custom/vehicleIcons/paver.svg",
	"./plate-forme-elevatrice.svg": "./app/assets/custom/vehicleIcons/plate-forme-elevatrice.svg",
	"./recycle.svg": "./app/assets/custom/vehicleIcons/recycle.svg",
	"./roller.svg": "./app/assets/custom/vehicleIcons/roller.svg",
	"./semi-trailer.svg": "./app/assets/custom/vehicleIcons/semi-trailer.svg",
	"./snow-plow.svg": "./app/assets/custom/vehicleIcons/snow-plow.svg",
	"./soudeuse.svg": "./app/assets/custom/vehicleIcons/soudeuse.svg",
	"./truck-tractor.svg": "./app/assets/custom/vehicleIcons/truck-tractor.svg",
	"./truck-trash.svg": "./app/assets/custom/vehicleIcons/truck-trash.svg",
	"./truck.svg": "./app/assets/custom/vehicleIcons/truck.svg",
	"./vehicle-green.svg": "./app/assets/custom/vehicleIcons/vehicle-green.svg",
	"./vehicle.svg": "./app/assets/custom/vehicleIcons/vehicle.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/custom/vehicleIcons sync recursive .svg$";